const e = [
  {
    inputs: [],
    stateMutability: "nonpayable",
    type: "constructor"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !1,
        internalType: "address",
        name: "_admin",
        type: "address"
      },
      {
        indexed: !1,
        internalType: "bool",
        name: "_enabled",
        type: "bool"
      }
    ],
    name: "AdminAccessSet",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !1,
        internalType: "address",
        name: "previousAdmin",
        type: "address"
      },
      {
        indexed: !1,
        internalType: "address",
        name: "newAdmin",
        type: "address"
      }
    ],
    name: "AdminChanged",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !0,
        internalType: "address",
        name: "_planetOwner",
        type: "address"
      },
      {
        indexed: !1,
        internalType: "uint256",
        name: "_planetID",
        type: "uint256"
      },
      {
        indexed: !1,
        internalType: "string",
        name: "_seedPlanetID",
        type: "string"
      },
      {
        indexed: !1,
        internalType: "uint256",
        name: "_tokenID",
        type: "uint256"
      },
      {
        indexed: !1,
        internalType: "uint256",
        name: "_apostleID",
        type: "uint256"
      },
      {
        indexed: !1,
        internalType: "uint256",
        name: "_gene",
        type: "uint256"
      },
      {
        indexed: !1,
        internalType: "uint256",
        name: "_iv",
        type: "uint256"
      },
      {
        indexed: !1,
        internalType: "bool",
        name: "_isFreeMint",
        type: "bool"
      },
      {
        indexed: !1,
        internalType: "uint256",
        name: "_planetForgeStage",
        type: "uint256"
      }
    ],
    name: "ApostleForgeSuccess",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !0,
        internalType: "address",
        name: "_planetOwner",
        type: "address"
      },
      {
        components: [
          {
            internalType: "uint256",
            name: "planetID",
            type: "uint256"
          },
          {
            internalType: "string",
            name: "seedPlanetID",
            type: "string"
          },
          {
            internalType: "uint256[]",
            name: "apostleIDs",
            type: "uint256[]"
          },
          {
            internalType: "uint256[]",
            name: "genes",
            type: "uint256[]"
          },
          {
            internalType: "uint256[]",
            name: "ivs",
            type: "uint256[]"
          },
          {
            internalType: "uint256[]",
            name: "resetAgeCounts",
            type: "uint256[]"
          },
          {
            internalType: "bool[]",
            name: "isFreeMints",
            type: "bool[]"
          }
        ],
        indexed: !1,
        internalType: "struct ReservedApostleForge.ApostlePayload[]",
        name: "_payloads",
        type: "tuple[]"
      },
      {
        components: [
          {
            internalType: "uint256",
            name: "lastRecordedForgeStage",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "lastRecordedForgeTime",
            type: "uint256"
          }
        ],
        indexed: !1,
        internalType: "struct ReservedApostleForge.PlanetForgeStageData[]",
        name: "_forgeStageDatas",
        type: "tuple[]"
      }
    ],
    name: "ApostleForgeSummary",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !0,
        internalType: "address",
        name: "beacon",
        type: "address"
      }
    ],
    name: "BeaconUpgraded",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !1,
        internalType: "uint8",
        name: "_mintType",
        type: "uint8"
      }
    ],
    name: "MintPriceUpdated",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !0,
        internalType: "address",
        name: "previousOwner",
        type: "address"
      },
      {
        indexed: !0,
        internalType: "address",
        name: "newOwner",
        type: "address"
      }
    ],
    name: "OwnershipTransferred",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !0,
        internalType: "uint8",
        name: "_mintType",
        type: "uint8"
      },
      {
        indexed: !1,
        internalType: "uint256",
        name: "_saleSchedule",
        type: "uint256"
      }
    ],
    name: "SaleScheduleUpdated",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !0,
        internalType: "address",
        name: "implementation",
        type: "address"
      }
    ],
    name: "Upgraded",
    type: "event"
  },
  {
    inputs: [
      {
        internalType: "uint8",
        name: "",
        type: "uint8"
      },
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    name: "addressFreeMintedMapping",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint8",
        name: "_mintType",
        type: "uint8"
      },
      {
        internalType: "uint256",
        name: "_userMaxFreeMintCount",
        type: "uint256"
      },
      {
        components: [
          {
            internalType: "uint256",
            name: "planetID",
            type: "uint256"
          },
          {
            internalType: "string",
            name: "seedPlanetID",
            type: "string"
          },
          {
            internalType: "uint256[]",
            name: "apostleIDs",
            type: "uint256[]"
          },
          {
            internalType: "uint256[]",
            name: "genes",
            type: "uint256[]"
          },
          {
            internalType: "uint256[]",
            name: "ivs",
            type: "uint256[]"
          },
          {
            internalType: "uint256[]",
            name: "resetAgeCounts",
            type: "uint256[]"
          },
          {
            internalType: "bool[]",
            name: "isFreeMints",
            type: "bool[]"
          }
        ],
        internalType: "struct ReservedApostleForge.ApostlePayload[]",
        name: "_payloads",
        type: "tuple[]"
      },
      {
        internalType: "uint256",
        name: "_time",
        type: "uint256"
      },
      {
        internalType: "bytes",
        name: "_signature",
        type: "bytes"
      }
    ],
    name: "forgeReservedApostle",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "forgeStageResetTime",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint8",
        name: "_mintType",
        type: "uint8"
      }
    ],
    name: "getMintPriceArray",
    outputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "AprsCost",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "AnimaCost",
            type: "uint256"
          }
        ],
        internalType: "struct ReservedApostleForge.TokenCost[]",
        name: "",
        type: "tuple[]"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "initialize",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "admin",
        type: "address"
      }
    ],
    name: "isAdmin",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "isEnabled",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    name: "mintedForgeApostleIdMapping",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_to",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "_aprsAmount",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "_animaAmount",
        type: "uint256"
      }
    ],
    name: "ownerTransferToken",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    name: "planetLastForgeStageDataMapping",
    outputs: [
      {
        internalType: "uint256",
        name: "lastRecordedForgeStage",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "lastRecordedForgeTime",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint8",
        name: "",
        type: "uint8"
      }
    ],
    name: "resetAgeCountCost",
    outputs: [
      {
        internalType: "uint256",
        name: "AprsCost",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "AnimaCost",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "",
        type: "string"
      }
    ],
    name: "seedPlanetLastForgeStageDataMapping",
    outputs: [
      {
        internalType: "uint256",
        name: "lastRecordedForgeStage",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "lastRecordedForgeTime",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "admin",
        type: "address"
      },
      {
        internalType: "bool",
        name: "enabled",
        type: "bool"
      }
    ],
    name: "setAdmin",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "bool",
        name: "_isEnabled",
        type: "bool"
      }
    ],
    name: "setEnabled",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint8",
        name: "_mintType",
        type: "uint8"
      },
      {
        internalType: "uint256",
        name: "_time",
        type: "uint256"
      }
    ],
    name: "setForSaleSchedule",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint8",
        name: "_mintType",
        type: "uint8"
      },
      {
        components: [
          {
            internalType: "uint256",
            name: "AprsCost",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "AnimaCost",
            type: "uint256"
          }
        ],
        internalType: "struct ReservedApostleForge.TokenCost[]",
        name: "_mintPriceArray",
        type: "tuple[]"
      },
      {
        components: [
          {
            internalType: "uint256",
            name: "AprsCost",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "AnimaCost",
            type: "uint256"
          }
        ],
        internalType: "struct ReservedApostleForge.TokenCost",
        name: "_resetAgeCountCost",
        type: "tuple"
      }
    ],
    name: "setupMintPriceByType",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "tokenReceiptHandler",
    outputs: [
      {
        internalType: "contract ITokenReceiptHandler",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address"
      }
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_tokenReceiptHandler",
        type: "address"
      },
      {
        internalType: "address",
        name: "_planetAddress",
        type: "address"
      },
      {
        internalType: "address",
        name: "_apostleAddress",
        type: "address"
      },
      {
        internalType: "address",
        name: "_aprsAddress",
        type: "address"
      },
      {
        internalType: "address",
        name: "_animaAddress",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "_forgeStageResetTime",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "_systemAddress",
        type: "address"
      }
    ],
    name: "updateContractSetting",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newImplementation",
        type: "address"
      }
    ],
    name: "upgradeTo",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newImplementation",
        type: "address"
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes"
      }
    ],
    name: "upgradeToAndCall",
    outputs: [],
    stateMutability: "payable",
    type: "function"
  }
];
export {
  e as default
};
//# sourceMappingURL=ronin-planet-apostle-forge.json.js.map
